import httpManager from "@/app/shared/utils/httpManager";

export async function fetchTtsAudioGenerationInfo(strategyId) {
  const response = await httpManager.get(
    `/strategies/${strategyId}/tts-audio-generation-info/`
  );
  return response?.data;
}
